(function () {
  angular
    .module('app.full', ['app.main', 'ngRoute', 'ngFileUpload', 'ngImgCrop', 'angular-img-cropper', 'slugifier', 'ui.sortable', 'ngTable', 'ui.utils.masks', 'pascalprecht.translate', 'ngMask'])
    .constant('STATIC_FS', 'syscall-local')
    .constant('RouteConfig', appRoutes)
    .factory('ReqAndUpload', function ($q, Upload, Api, STATIC_FS, $window) {
      return {
        upload: function (file, scope, id) {
          var deferred = $q.defer();
          var user = $window.localStorage && $window.localStorage.getItem('session') ? JSON.parse($window.localStorage.getItem('session')) : false;
          var bcsetup = $window.localStorage && $window.localStorage.getItem('_bcsetup') ? JSON.parse($window.localStorage.getItem('_bcsetup')) : false;
          if (bcsetup && user && file && file.name != undefined) {
            var payload = {
              file_alias: file.name,
              size: file.size
            };
            var call = null;
            if (scope === 'user') call = `file?user_id=${user.user_id}`;
            else if (scope === 'project') call = `file?project_id=${bcsetup.project_id}`;
            else if (scope === 'course') call = `course/${id}/file`;
            else return false;
            Api.post(call, payload, function (err, resp) {
              if (err) {
                deferred.resolve(false);
              } else {
                var fields = resp.response.gcs_upload_data;
                var filename = resp.response.file_name;
                fields.file = file;
                if (resp.response.file_exists) {
                  deferred.resolve(filename);
                } else {
                  delete fields.file_exists;
                  Upload.upload({
                    url: 'https://' + STATIC_FS + '.storage.googleapis.com',
                    data: fields
                  }).then(
                    function (resp) {
                      deferred.resolve(filename);
                    },
                    function (resp) {
                      deferred.resolve(false);
                    },
                    function (evt) {
                      var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
                    }
                  );
                }
              }
            });
          } else {
            deferred.resolve(false);
          }
          return deferred.promise;
        }
      };
    })
    .run(function ($http) {
      $http.defaults.headers.bcp = _bcp;
      $http.defaults.headers.Authorization = `Bearer ${window.localStorage.getItem('auth-token')}`;
    })
    .controller('appFullCtrl', function ($scope, $window, $http) {
      var user = $scope.$parent.currentUser;
      var userVerification = function () {
        if (!user && !localStorage.getItem('communitySquid/community_squid/auth-token')) {
          let queryString = unserialize(window.location.href.split('?').pop());
          if (!queryString['token']) {
            window.location.href = '/';
          }
        }

        if (user.pending_email_verification) {
          $window.location.href = '/';
        }

        $scope.progress = 0;
      };

      if (user) {
        userVerification();
      } else {
        $scope.$parent.syncData(function (newUser) {
          user = newUser;
          userVerification();
        });
      }

      $scope.$on('$viewContentLoaded', function () {
        window.scrollTo(0, 0);
      });

      $scope.getAddress = function (cep, model, prefix) {
        $http({
          method: 'GET',
          url: 'https://viacep.com.br/ws/' + cep + '/json/'
        }).then(function successCallback(response) {
          var fields = response.data ? response.data : false;
          if (fields.logradouro) {
            model[prefix + '_address'] = fields.logradouro.split(' - ')[0];
            model[prefix + '_city'] = fields.localidade;
            model[prefix + '_bairro'] = fields.bairro;
            model[prefix + '_uf'] = fields.uf;
          }
        });
      };
    })
    .directive('convertToNumber', function () {
      return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
          ngModel.$parsers.push(function (val) {
            return parseInt(val, 10);
          });
          ngModel.$formatters.push(function (val) {
            return '' + val;
          });
        }
      };
    });
})();
